import { render, staticRenderFns } from "./proof-view-navigation.vue?vue&type=template&id=21636055&scoped=true&"
import script from "./proof-view-navigation.vue?vue&type=script&lang=js&"
export * from "./proof-view-navigation.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-navigation.vue?vue&type=style&index=0&id=21636055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21636055",
  null
  
)

export default component.exports